import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * session-create operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const createSession = async ({
  request,
}: {
  request: ApiTypes["session-create"]["request"];
}): Promise<ApiTypes["session-create"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["session-create"]["response"]
    >(`/api/public/v2025-06/session`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to createSession");
    throw error;
  }
};
